// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("../TypeUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function toEnum(param) {
  switch (param) {
    case 0 :
        return /* Ineligible */0;
    case 1 :
        return /* SignedUp */1;
    case 2 :
        return /* AttendedOrientation */2;
    case 3 :
        return /* ConfiguredStripe */3;
    case 4 :
        return /* FoodHandler */4;
    case 5 :
        return /* FoodAndAlcoholHandler */5;
    default:
      return ;
  }
}

function fromEnum(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 6;
  }
}

var include = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

function toString(x) {
  if (typeof x !== "number") {
    return Relude_Int.toString(x._0) + " - Unknown Active Id";
  }
  switch (x) {
    case /* Ineligible */0 :
        return "0 - Ineligible";
    case /* SignedUp */1 :
        return "1 - Signed Up";
    case /* AttendedOrientation */2 :
        return "2 - Orientation";
    case /* ConfiguredStripe */3 :
        return "11 - Ori, Stripe";
    case /* FoodHandler */4 :
        return "12 - Ori, Stripe, FHC";
    case /* FoodAndAlcoholHandler */5 :
        return "13 - Ori, Stripe, FHC, AC";
    
  }
}

function toEnum$1(x) {
  switch (x) {
    case 0 :
        return /* Ineligible */0;
    case 1 :
        return /* SignedUp */1;
    case 2 :
        return /* AttendedOrientation */2;
    case 3 :
    case 4 :
    case 5 :
    case 6 :
    case 7 :
    case 8 :
    case 9 :
    case 10 :
        return /* FutureAddedValue */{
                _0: x
              };
    case 11 :
        return /* ConfiguredStripe */3;
    case 12 :
        return /* FoodHandler */4;
    case 13 :
        return /* FoodAndAlcoholHandler */5;
    default:
      return /* FutureAddedValue */{
              _0: x
            };
  }
}

function fromEnum$1(x) {
  if (typeof x !== "number") {
    return x._0;
  }
  switch (x) {
    case /* Ineligible */0 :
        return 0;
    case /* SignedUp */1 :
        return 1;
    case /* AttendedOrientation */2 :
        return 2;
    case /* ConfiguredStripe */3 :
        return 11;
    case /* FoodHandler */4 :
        return 12;
    case /* FoodAndAlcoholHandler */5 :
        return 13;
    
  }
}

var compare = Curry._1(Relude_Int.compareWithConversion, fromEnum$1);

var eq = Curry._1(Relude_Int.eqWithConversion, fromEnum$1);

var decode = Curry._1(Json.Decode.variantFromInt, (function (param) {
        return Relude_Globals.$great$great(toEnum$1, Relude_Option.pure, param);
      }));

function encode(param) {
  return Relude_Globals.$great$great(fromEnum$1, (function (prim) {
                return prim;
              }), param);
}

var Ord = include.Ord;

var compareWithConversion = include.compareWithConversion;

var compareReversed = include.compareReversed;

var OrdReversed = include.OrdReversed;

var compareAsInt = include.compareAsInt;

var min = include.min;

var max = include.max;

var lessThan = include.lessThan;

var lt = include.lt;

var lessThanOrEq = include.lessThanOrEq;

var lte = include.lte;

var greaterThan = include.greaterThan;

var gt = include.gt;

var greaterThanOrEq = include.greaterThanOrEq;

var gte = include.gte;

var clamp = include.clamp;

var between = include.between;

var OrdRingExtensions = include.OrdRingExtensions;

var OrdNamed = include.OrdNamed;

var OrdBy = include.OrdBy;

var $$Set = include.$$Set;

var SetWithNone = include.SetWithNone;

var $$Map = include.$$Map;

var list = include.list;

var array = include.array;

var set = include.set;

var setWithNone = include.setWithNone;

var cardinality = include.cardinality;

var top = include.top;

var bottom = include.bottom;

var succ = include.succ;

var pred = include.pred;

exports.Ord = Ord;
exports.compareWithConversion = compareWithConversion;
exports.compareReversed = compareReversed;
exports.OrdReversed = OrdReversed;
exports.compareAsInt = compareAsInt;
exports.min = min;
exports.max = max;
exports.lessThan = lessThan;
exports.lt = lt;
exports.lessThanOrEq = lessThanOrEq;
exports.lte = lte;
exports.greaterThan = greaterThan;
exports.gt = gt;
exports.greaterThanOrEq = greaterThanOrEq;
exports.gte = gte;
exports.clamp = clamp;
exports.between = between;
exports.OrdRingExtensions = OrdRingExtensions;
exports.OrdNamed = OrdNamed;
exports.OrdBy = OrdBy;
exports.$$Set = $$Set;
exports.SetWithNone = SetWithNone;
exports.$$Map = $$Map;
exports.list = list;
exports.array = array;
exports.set = set;
exports.setWithNone = setWithNone;
exports.cardinality = cardinality;
exports.top = top;
exports.bottom = bottom;
exports.succ = succ;
exports.pred = pred;
exports.toString = toString;
exports.toEnum = toEnum$1;
exports.fromEnum = fromEnum$1;
exports.compare = compare;
exports.eq = eq;
exports.decode = decode;
exports.encode = encode;
/* include Not a pure module */
